import {
  Box,
  Button,
  createStyles,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  Link,
  makeStyles,
  Theme,
  Typography
} from '@material-ui/core';
import { LowPriority, OpenInNew } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { useHistory } from 'react-router';
import VoxelDialog from '../../../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActions from '../../../../../components/voxel/Dialogs/VoxelDialogActions';
import { ProjectTabChoices } from '../../../../ProjectPage/ProjectPage';
import { SelectUrlBag } from '../ContentTaskDialog/useSelectUrl';

export interface ContentTaskUrlDialogProps {
  selectUrlBag: SelectUrlBag;
  projectId: number;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      opacity: 0,
    },
  })
);

export const ContentTaskUrlDialog: React.FC<ContentTaskUrlDialogProps> = ({
  selectUrlBag,
  projectId,
}) => {
  const classes = useClasses();
  const history = useHistory();
  return (
    <VoxelDialog
      open={!!selectUrlBag.evaluatedUrl?.length}
      onClose={() => selectUrlBag.setEvaluatedUrl('')}
    >
      <DialogTitle>
        <Typography variant="subtitle2">Update url to</Typography>
        <Typography variant="body2">
          <Link href={selectUrlBag.evaluatedUrl} target="_blank">
            {selectUrlBag.evaluatedUrl}
          </Link>
        </Typography>
      </DialogTitle>
      {!!selectUrlBag.contentTasks?.length && (
        <DialogContent>
          <Alert severity="error">
            <Typography variant="subtitle2" color="inherit">
              Duplicates not allowed
            </Typography>
            <Typography variant="body2" color="inherit">
              The URL already exists in content plan.
            </Typography>
            <Box pt={2}>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Button
                    variant="outlined"
                    color="inherit"
                    href={`/${projectId}/${ProjectTabChoices.Plan}/${selectUrlBag.contentTasks[0].id}`}
                    onClick={(event) => {
                      event.preventDefault(); // We prevent default, but still have the href so user's can right click and open in new tab
                      history.push(
                        `/${projectId}/${ProjectTabChoices.Plan}/${selectUrlBag.contentTasks[0].id}`
                      ); // By using history the entire application doesn't need to reload
                      selectUrlBag.setEvaluatedUrl('');
                    }}
                    size="small"
                    endIcon={<OpenInNew fontSize="small" />}
                  >
                    View URL in plan
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="inherit"
                    endIcon={<LowPriority fontSize="small" />}
                    disabled={selectUrlBag.loading || selectUrlBag.updating}
                    size="small"
                    onClick={() => selectUrlBag.handleMove(selectUrlBag.contentTasks[0].id)}
                  >
                    Move the keywords there
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Alert>
        </DialogContent>
      )}
      {!!selectUrlBag.renameOk && (
        <VoxelDialogActions>
          <>
            <Button
              size="small"
              onClick={selectUrlBag.nandleClose}
              disabled={selectUrlBag.loading || selectUrlBag.updating}
            >
              Cancel
            </Button>
            <Button
              size="small"
              disabled={selectUrlBag.loading || !selectUrlBag.renameOk || selectUrlBag.updating}
              onClick={selectUrlBag.handleRename}
            >
              Confirm
            </Button>
          </>

        </VoxelDialogActions>
      )}
      <LinearProgress
        className={selectUrlBag.loading || selectUrlBag.updating ? '' : classes.hidden}
      />
    </VoxelDialog>
  );
};

export default ContentTaskUrlDialog;
